import { apiClient } from "../axios.config";
import type { MainRequest, GolfParkSearchRequest, MainGolfParkDetailRequest } from "../dto/request/main.request";
import type { Response } from "../dto/response/common.response";
import type { GolfParkSearchResponse, MainGolfParkDetailResponse, MainParkgolfTournamenteResponse } from "../dto/response/main.response";

const model = '/v1/main';

/**
 * Main Service API
 * @module MainService
 * @description 메인화면 관련 API
 * @author DongGyun Yoo
 * @since 1.0.0
 */
export async function getMainData(form?: MainRequest): Promise<Response<MainParkgolfTournamenteResponse>> {
    const { data } = await apiClient.get(model, {
        params: { ...form, pageSize: 6 },
    });
    return data;
}

export async function getMainDetail(code: string, form?: MainGolfParkDetailRequest): Promise<Response<MainGolfParkDetailResponse>> {
  const { data } = await apiClient.get(`${model}/detail/golfpark/${code}/detail`, {
    params: form,
  });
  return data;
}


/** 골프장 검색 */
export async function mainGolfParkSearch(form?: GolfParkSearchRequest): Promise<Response<{ golfParkList: GolfParkSearchResponse[] }>> {
  const { data } = await apiClient.get(`${model}/golfpark/search`, {
    params: form,
  });
  return data;
}

export async function getGolfparkDetail(code: string): Promise<Response<MainGolfParkDetailResponse>> {
  const { data } = await apiClient.get(`${model}/golfpark/${code}/detail`);
  return data;
}

/** 홀 정보 */
export async function getGolfHoleList(courseCode: string) {
  const { data } = await apiClient.get(`/v1/score/course/${courseCode}/hole-list`);
  return data;
}
